import React, { useCallback, useState } from "react";
import { MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const useStyles = makeStyles(theme => ({
  rangeSelect: {
    minWidth: 95,
  },
}));

export const calculateDate = range => {
  if (range === dateRanges.all) {
    return null;
  }

  const adjustment =
    range === dateRanges.last_30
      ? 30
      : range === dateRanges.last_14
      ? 14
      : range === dateRanges.last_7
      ? 7
      : 0;

  const currDate = new Date();
  currDate.setDate(currDate.getDate() - adjustment);
  currDate.setUTCHours(0, 0, 0, 0);
  const dateString = currDate
    .toISOString()
    .substring(0, currDate.toISOString().lastIndexOf("."));
  return `${dateString}Z`;
};

export const dateRanges = {
  all: "ALL",
  last_30: "LAST_30",
  last_14: "LAST_14",
  last_7: "LAST_7",
  today: "TODAY",
};

const DateRangeSelect = ({
  onDateRangeChange,
  initialRange = dateRanges.last_30,
}) => {
  const classes = useStyles();

  const [selectedDateRange, setSelectedDateRange] = useState(initialRange);

  const handleDateRangeChange = useCallback(
    event => {
      const value = event.target.value;
      setSelectedDateRange(value);
      onDateRangeChange(calculateDate(value));
    },
    [onDateRangeChange],
  );

  return (
    <FormControl classes={{ root: classes.rangeSelect }}>
      <Select
        IconComponent={KeyboardArrowDownIcon}
        disableUnderline
        value={selectedDateRange}
        onChange={handleDateRangeChange}
      >
        <MenuItem value={dateRanges.all}>All</MenuItem>
        <MenuItem value={dateRanges.last_30}>Last 30 Days</MenuItem>
        <MenuItem value={dateRanges.last_7}>Last 7 Days</MenuItem>
        <MenuItem value={dateRanges.today}>Today</MenuItem>
      </Select>
    </FormControl>
  );
};

export default DateRangeSelect;
